<template>
  <b-sidebar
    :sidebar-class="`${changed_sidebar ? 'sidebar-animation' : ''}`"
    bg-variant="white"
    right
    backdrop
    shadow
    width="500px"
    v-model="show"
    @change="changedSidebar"
  >
    <b-overlay
      :show="addInfluencers"
      rounded="sm"
    >
      <b-card>
        <b-row class="match-height">
          <b-col
            md="12"
          >
            <h2>{{$t('campaigns.add_influencer')}}</h2>
            <small>{{$t('campaigns.addInfluencer-description')}}</small>
          </b-col>
          <b-col
            md="12"
            class="mt-1"
          >
          <b-tabs pills v-model="active_tab">
                <b-tab
                v-on:click="changeProfile('')"
                :title= "$t('campaigns.all')"
                active
                >
                </b-tab>
                <b-tab
                v-on:click="changeProfile('youtube')"
                title-link-class="tab-nav-youtube"
                >
                  <template #title>
                    <feather-icon class="margin-icons" icon="YoutubeIcon" size="20"/>
                  </template>
                </b-tab>
                <b-tab
                v-on:click="changeProfile('instagram')"
                title-link-class="tab-nav-instagram"
                >
                  <template #title>
                    <feather-icon class="margin-icons" icon="InstagramIcon" size="16"/>
                  </template>
                </b-tab>
                <b-tab
                v-on:click="changeProfile('tiktok')"
                title-link-class="tab-nav-tiktok"
                >
                  <template #title>
                    <span class="icomoon-tiktok tiktokIconAnalize"></span>
                  </template>
                </b-tab>
                <b-tab
                v-on:click="changeProfile('twitch')"
                title-link-class="tab-nav-twitch"
                >
                  <template #title>
                    <feather-icon class="margin-icons" icon="TwitchIcon" size="20"/>
                  </template>
                </b-tab>
                <b-tab
                v-on:click="changeProfile('twitter')"
                title-link-class="tab-nav-twitter"
                >
                  <template #title>
                    <b-img src="@/assets/images/icons/twitter-x-black.svg" class="network-x-tabs"/>
                  </template>
                </b-tab>
            </b-tabs>
          </b-col>
          <b-col
            md="12"
            class="mb-1"
            style="position: relative"
          >
            <b-spinner
              v-show="loading"
              variant="primary"
              label="Text Centered"
              style="position: absolute; right: 30px; top: 5px"
            />
            <vue-autosuggest
            v-model="query"
            :suggestions="filteredOptions"
            :input-props="inputProps"
            :limit="10"
            @input="handleInput"
            @click="resetQuery"
            @selected="selectInfluencer"
            :get-suggestion-value="getSuggestionValue"
            class="cursor-pointer"
            ref="inputSearch"
            :should-render-suggestions="shouldRenderSuggestions"
          >
          <template slot-scope="{suggestion}">
            <chat-contact
                class="p-0"
                :padding_component="'p-0'"
                :user="suggestion.item"
                tag="li"
                is-chat-contact
              />
          </template>
          <template slot="before-suggestions">
            <div
              class="m-1"
              v-if="query !== '' && !no_suggestions"
            >
              {{$t('search.searchingBy')}}: {{query}}
            </div>
            <hr class="m-0" v-if="query !== '' && !no_suggestions">
          </template>
          <template slot="before-suggestions">
            <div
              class="m-1"
              v-if="no_suggestions"
            >
            {{$t('lists.noresults')}} {{query}}

            </div>
          </template>
          </vue-autosuggest>
          <div
            v-if="localValue === 'youtube' && no_suggestions && !youtubeUrlResult"
            class="youtube-url-hint mt-1 p-1"
          >
            <feather-icon icon="InfoIcon" size="14" class="mr-25 text-primary" />
            <span>{{ $t('campaigns.youtubeUrlHint') }}</span>
            <br/>
            <small class="text-muted">
              https://www.youtube.com/channel/UC...<br/>
              https://www.youtube.com/@handle
            </small>
          </div>
          </b-col>
          <div class="col-12 mb-1 list-influencer-add">
            <b-list-group v-if="selected !== null" class="col-12">
              <b-list-group-item v-for="(item, index) in selected" :key="index">
                <div class="d-flex align-items-center">
                  <b-avatar :src="item.avatar_url" badge-variant="ligth" size="42">
                    <template #badge>
                      <b-avatar size="18px" class="avatar-absolute" variant="ligth">
                        <b-img :src="getIconWhite(item.type)" :class="getIconColor(item.type, false)" fluid/>
                      </b-avatar>
                    </template>
                  </b-avatar>
                  <div class="chat-info flex-grow-1">
                    <h5 class="mb-0 pl-1">
                      {{ item.title }}
                      <image-verified
                        v-if="item.is_verified"
                        class="is-verified"
                      />
                    </h5>
                    <p class="card-text text-truncate pl-1">
                      {{ getFormat(item.subscribers_count) }}
                    </p>
                  </div>

                  <feather-icon class="cursor-pointer" icon="XIcon" @click="deleteFromList(item)"></feather-icon>
                </div>
              </b-list-group-item>
            </b-list-group>
          </div>
          <b-col
            lg="12"
          >
            <b-button
              class="blue-button"
              variant="blue-button"            
              :disabled="disabledUpdateCampaign() || selected.length === 0"
              @click="addInfoInfluencer()"
            >
            {{$t('lists.add')}}
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </b-sidebar>
</template>

<script>
import {
  BRow, BCol, BCard, BButton, BTab, BTabs, BOverlay, BSpinner, BAvatar, BListGroup, BListGroupItem, BSidebar, BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');
import campaignService from '@/services/campaign'
import { VueAutosuggest } from 'vue-autosuggest'
import ChatContact from '@/views/apps/chat/ChatContact.vue'
import axios from 'axios'
import config from '@/services/config'
import service_profile from '@/services/others'
import ImageVerified from '@/views/components/image/ImageVerified.vue';
import { getIconWhite, getIconColor } from '@/libs/utils/icons'
import { getFormat, trimText } from '@/libs/utils/formats';
import { hasPermission } from '@/libs/utils/user';
import { getUserData } from '@/auth/utils';

export default {
  components: {
    BImg,
    ImageVerified,
    BRow,
    BCol,
    BCard,
    BButton,
    BTab,
    BTabs,
    BOverlay,
    BSpinner,
    VueAutosuggest,
    ChatContact,
    BAvatar,
    BListGroup,
    BListGroupItem,
    BSidebar,
  },
  directives: {
    Ripple
  },
  data () {
    return {
      hasPermission,
      trimText,
      getFormat,
      getIconWhite,
      getIconColor,
      addInfluencers: false,
      typingTimer: null,
      query: '',
      filteredOptions: [],
      inputProps: {
        id: 'autosuggest__input',
        class: 'form-control',
        placeholder: this.$t('lists.searchInfluencer'),
        autocomplete: 'new-password',
        'data-1p-ignore': true,
        'data-lpignore': true
      },
      selected: [],
      loading: false,
      cancel: null,
      localValue: '',
      no_suggestions: false,
      active_tab: 0,
      influencersAdd: [],
      show: this.show_side_influencer,
      changed_sidebar: true,
      youtubeUrlResult: null,
    }
  },
  props: {
    list_service: {
      type: Boolean,
      default: false
    },
    show_side_influencer: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    changedSidebar(val) {
      this.changed_sidebar = val;
    },
    deleteFromList(item) {
      if (item.type === 'youtube') {
        this.selected = this.selected.filter((s) => s.channel_id !== item.channel_id)
        this.influencersAdd = this.influencersAdd.filter((i) => i.channel_id !== item.channel_id)
      } else {
        this.selected = this.selected.filter((s) => s.user_id !== item.user_id)
        this.influencersAdd = this.influencersAdd.filter((i) => i.username !== item.username)
      }
    },
    engagement (num) {
      let result = ''
      if (num > 999) {
        result = `${(Math.round(num / 100) / 10)} K`
      }
      if (num > 999999) {
        result = `${(Math.round(num / 100000) / 10)} M`
      }
      if (num > 999999999) {
        result = `${(Math.round(num / 100000000) / 10)} B`
      }
      return result
    },
    changeProfile (red) {
      this.localValue = red
      this.query = ''
      this.no_suggestions = false
      this.youtubeUrlResult = null
      this.filteredOptions = []
    },
    resetQuery () {
      if (this.query === '') {
        this.inputProps.class = 'form-control'
        this.filteredOptions = []
      }
    },
    handleInput() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(this.getResults, 300); //300 ms o el tiempo que se necesite
    },
    parseYouTubeInput (text) {
      try {
        const url = new URL(text)
        if (!url.hostname.includes('youtube.com')) return { isUrl: false }

        // https://www.youtube.com/channel/UCxxxxxxx
        const channelMatch = url.pathname.match(/\/channel\/(UC[\w-]+)/)
        if (channelMatch) return { isUrl: true, type: 'channel_id', value: channelMatch[1] }

        // https://www.youtube.com/@handle
        const handleMatch = url.pathname.match(/\/@([\w.-]+)/)
        if (handleMatch) return { isUrl: true, type: 'handle', value: handleMatch[1] }

        return { isUrl: true, type: null, value: null }
      } catch {
        return { isUrl: false }
      }
    },
    searchByYouTubeUrl (parsed) {
      this.loading = true
      this.youtubeUrlResult = null
      const self = this
      const CancelToken = axios.CancelToken
      if (this.cancel) this.cancel()

      axios({
        method: 'get',
        url: `${config.urlCore}/api/v4/internal-campaigns/search-user-youtube-channel/${parsed.value}/`,
        headers: { 'Authorization': `Bearer ${localStorage.getItem('accessToken')}` },
        cancelToken: new CancelToken(c => { self.cancel = c })
      })
        .then(res => {
          const channel = res.data.response
          if (channel && res.data.status === 'OK' && Object.keys(channel).length > 0) {
            // Extraer el channel_id desde "channels/UCxxxxxxx"
            const channel_id = channel.name ? channel.name.replace('channels/', '') : parsed.value

            const item = {
              type: 'youtube',
              channel_id,
              username: (channel.channelHandle || parsed.value).replace(/^@/, ''),
              title: channel.title,
              full_name: channel.title,
              avatar_url: channel.thumbnailUri,
              subscribers_count: parseInt(channel.subscriberCount) || 0,
              is_verified: false,
            }
            self.youtubeUrlResult = item
            self.filteredOptions = [{ data: [item] }]
            self.no_suggestions = false
          } else {
            self.no_suggestions = true
          }
          self.loading = false
        })
        .catch(error => {
          if (!axios.isCancel(error)) {
            self.no_suggestions = true
            self.loading = false
          }
        })
    },
    getResults () {
      this.filteredOptions = []
      this.no_suggestions = false
      this.youtubeUrlResult = null

      if (this.query !== '') {
        // Si el tab es YouTube y el usuario pegó una URL, consumir servicio dedicado
        if (this.localValue === 'youtube') {
          const parsed = this.parseYouTubeInput(this.query)
          if (parsed.isUrl && parsed.value) {
            this.searchByYouTubeUrl(parsed)
            return
          }
        }

        this.loading = true;
        const CancelToken = axios.CancelToken;

        if (this.cancel) this.cancel()

        const self = this;
        axios({
          method: 'post',
          url: `${config.urlCore}/api/v1/finder/suggester/`,
          data: {
            query: trimText(this.query),
            networks: this.localValue,
          },
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,

          },
          cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            self.cancel = c;
          })
        })
          .then(res => {
            self.filteredOptions = [{data: res.data.response.list}]
            self.no_suggestions = res.data.response.list.length === 0
            self.loading = false;
          })
          .catch(error => {
            if (axios.isCancel(error)) {
              console.log('');
            } else {
              self.no_suggestions = true;
              self.loading = false;
            }
          });
      }
    },
    selectInfluencer (info) {
      let value = '';
      info.item.type === 'youtube' ? value = 'channel_id' : value = 'user_id';
      if (this.selected.findIndex((item) => item[value] === info.item[value]) === -1) {
        this.selected.unshift(info.item);
        this.influencersAdd.push({
          influencer: info.item.type === 'youtube' ? info.item.username : (info?.item?.name ?? info?.item?.title),
          username: info.item.username,
          network: info.item.type, 
          image: info.item.avatar_url, 
          followers: info.item.subscribers_count, 
          is_verified: info.item.is_verified, 
          channel_id: info.item.channel_id
        });
      }
      this.query = info.item.username
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.username
    },
    shouldRenderSuggestions (size, loading) {
      return size >= 0 && !loading
    },
    disabledUpdateCampaign() {
      return !hasPermission('change_campaign')
    },
    addInfoInfluencer () {
      if (this.query !== '') {
        if (this.disabledUpdateCampaign()) return;

        if (this.list_service) {
          this.listService();
        } else {
          this.campaignService();
        }
        this.show = false;
      }
    },
    listService() {
      this.$emit('add_influencer', {influencers: this.influencersAdd});
      this.$emit('update_header_campaign');
    },
    campaignService() {
      const user = getUserData()
      campaignService.addInfluencersCampaign(this.$route.params.uuid, this.influencersAdd).then(e => {
        this.$emit('update_header_campaign');
        if (e.status === 400) {
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-left',
              props: {
                title: this.$t('campaigns.errorInfluencer'),
                icon: 'BellIcon',
                text: e.data.response.message,
                variant: 'danger'
              }
            })
          })
        } else if (e.status === 500) {
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-left',
              props: {
                title: this.$t('campaigns.errorInfluencer'),
                icon: 'BellIcon',
                text: e.data.response.message,
                variant: 'danger'
              }
            })
          })
        } else if (e.code === 'accounts.max_views_soldout') {
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-left',
              props: {
                title: user?.main_group?.name === 'espejo' ? this.$t('campaigns.errorInfluencerEspejo') : this.$t('campaigns.errorInfluencer'),
                icon: 'BellIcon',
                text: user?.main_group.name === 'espejo' ? this.$t('campaigns.max_views_soldout_espejo') : this.$t('campaigns.max_views_soldout'),
                variant: user?.main_group?.name === 'espejo' ? 'info' : 'danger'
              }
            })
          })
        } else {
          this.query = '';
          this.resetQuery();
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-left',
              props: {
                title: this.$t('campaigns.addedInfluencer'),
                icon: 'CheckCircleIcon',
                text: this.$t('campaigns.addSuccess'),
                variant: 'success'
              }
            })
          })
          service_profile.getMaxViews()
            .then(response => {
              this.$root.$emit('change_max_views', response.max_views)
            })
        }
        this.addInfluencers = false
        this.$emit('childPost')
      }).catch(
        this.addInfluencers = false
      )
    }
  },
  watch: {
    '$i18n.locale'() {
      this.inputProps.placeholder = this.$t('lists.searchInfluencer')
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';
</style>
<style>
  .list-influencer-add {
    max-height: 23em !important;
    overflow: hidden;
    overflow-y: scroll;
  }

  /* El tema usa .nav-pills .nav-link.active !important (0,3,0).
     Usamos .nav-pills .nav-link.tab-nav-*.active (0,4,0) para ganar. */

  /* Instagram */
  .nav-pills .nav-link.tab-nav-instagram.active {
    color: white !important;
    background: linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%) !important;
    border: none !important;
    box-shadow: rgba(220, 39, 67, 0.4) 0px 4px 15px 0px !important;
  }

  /* YouTube */
  .nav-pills .nav-link.tab-nav-youtube.active {
    color: white !important;
    background-color: #FF001D !important;
    border: none !important;
    box-shadow: rgba(255, 0, 29, 0.4) 0px 4px 15px 0px !important;
  }

  /* TikTok */
  .nav-pills .nav-link.tab-nav-tiktok.active {
    color: white !important;
    background-color: #010101 !important;
    border: none !important;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 4px 15px 0px !important;
  }
  .nav-pills .nav-link.tab-nav-tiktok.active .tiktokIconAnalize {
    color: white !important;
  }

  /* Twitch */
  .nav-pills .nav-link.tab-nav-twitch.active {
    color: white !important;
    background-color: #9146FF !important;
    border: none !important;
    box-shadow: rgba(145, 70, 255, 0.4) 0px 4px 15px 0px !important;
  }

  /* Twitter / X */
  .nav-pills .nav-link.tab-nav-twitter.active {
    color: white !important;
    background-color: #000000 !important;
    border: none !important;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 15px 0px !important;
  }
  .nav-pills .nav-link.tab-nav-twitter.active .network-x-tabs {
    filter: brightness(0) invert(1);
  }
</style>

<style>
  .b-sidebar-backdrop {
    background-color: rgba(0, 0, 0, 0.5) !important;
  }
</style>

<style scoped>
  .margin-icons {
    margin: 0px !important;
  }
  .avatar-absolute {
    position: absolute;
    left:4px
  }
  .network-x-tabs {
    color: black !important;
    width: 1.2em !important;
  }
  .radio label {
    position: relative;
    cursor: pointer;
    float: left;
    line-height: 40px;
    margin-bottom:0 !important;
  }
  .radio input {
    position: absolute;
    opacity: 0;
  }
  .radio input:checked ~ .radio-control {
    border-bottom: 1px solid red;
    color: red;
    margin-bottom:4px;
  }
  .autosuggest__results {
    margin-top: 0px !important;
  }
  .youtube-url-hint {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    background: #f9f9f9;
    font-size: 0.85rem;
    line-height: 1.6;
  }
  .tiktokIconAnalize {
  font-size: 1.1em;
  color: #444
  }
</style>
